import { DataConverter } from "../../../../Global/Base/Converters/DataConverter";
import { GenericControl as BaseGenericControl } from "../../../UI.BaseControls/GenericControl";

export class ControlUtils {
    /**
     * Metoda, která vrací true nebo false, na základě fyzické viditelnosti prvku
     */
    public static isElementVisible(element: HTMLElement): boolean {
        return BaseGenericControl.isElementVisible(element);
    }

    /**
     * Funkce vraci true, pokud je dana pozice v elementu
     * @param element Element
     * @param event Událost nebo souradnice
     * @returns true pokud je v elementu
     */
    public static inElement(element: HTMLElement, event: MouseEvent | { x: number; y: number }): boolean {
        let inEl = false;
        const pageX = event instanceof MouseEvent ? (event as MouseEvent).pageX : event.x;
        const pageY = event instanceof MouseEvent ? (event as MouseEvent).pageY : event.y;

        const pos = $(element).offset();

        if ((pageX > pos.left && pageX < ($(element).width() + pos.left)) && (pageY > pos.top && pageY < ($(element).height() + pos.top))) {
            inEl = true;
        }
        return inEl;
    }

    /**
     * Vrátí aktuální pozici kurzoru v zadaném elementu
     * @param el Element, ve kterém se vyhledává pozice kurzoru
     */
    public static getInputSelection(el: HTMLInputElement): { start: number; end: number } {
        let start = 0;
        let end = 0;

        if (typeof el.selectionStart === "number" && typeof el.selectionEnd === "number") {
            start = el.selectionStart;
            end = el.selectionEnd;
        }

        return {
            start: start,
            end: end,
        };
    }

    /**
     * Nastavi pozici kurzoru na dane misto
     * @link http://stackoverflow.com/questions/1865563/set-cursor-at-a-length-of-14-onfocus-of-a-textbox/1867393#1867393
     */
    public static setCaret(node: HTMLInputElement, pos: number): boolean {
        if (node.setSelectionRange) {
            node.setSelectionRange(pos, pos);
            return true;
        }
        return false;
    }

    /**
     * Nacita hodnotu data- atributu z html, vraci ji jako orezany string. Pokud atribut neexistuje, vraci null.
     * @param attr - nazev atributu bez data- prefixu
     * @param element
     */
    public static getDataAttr(attr: string, element: HTMLElement): string {
        const val = element && element.getAttribute("data-" + attr);
        return val == null ? val : val.trim();
    }

    /**
     * Nacita hodnotu data- atribut jako boolean; vraci true jedine kdyz hodnota je (case insensitive) retezec 'true', jinak false.
     * @param attr - nazev atributu bez data- prefixu
     * @param element
     * @param defaultValue
     */
    public static getBoolDataAttr(attr: string, element: HTMLElement, defaultValue?: boolean): boolean {
        const val = this.getDataAttr(attr, element);
        return DataConverter.toBoolean(val, defaultValue);
    }

    /**
     * Vraci hodnotu data- atributu jako cislo; pokud atribut neexistuje, je prazdny nebo NaN, vrati null.
     * @param attr - nazev atributu bez data- prefixu
     * @param element
     */
    public static getNumDataAttr(attr: string, element: HTMLElement): number | null {
        const val = this.getDataAttr(attr, element);
        if (val == null || val == "" || isNaN(+val))
            return null;
        return +val;
    }
}
